module.exports = __webpack_public_path__ + "img/school.c015df95.png";